import { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { LoadingScreen } from '@/components/feedback/loading-screen';
import PermissionGuard from '@/auth/guard/permission-guard';
import AdminGuard from '@/auth/guard/admin-guard';
import { OrionAccess, OrionModule, OrionSubmodule } from '@/types';

// Lazy load components
const ActivitiesOverviewPage = lazy(() => import('@/pages/account/activities-overview-page'));
const ActivitiesMyPage = lazy(() => import('@/pages/account/activities-my-page'));
const ActivitiesAllPage = lazy(() => import('@/pages/account/activities-all-page'));

export const activitiesRoutes = [
  {
    path: 'activities',
    element: (
      <PermissionGuard
        module={OrionModule.ACCOUNT}
        submodule={OrionSubmodule.ACCOUNT.ACTIVITY}
        access={OrionAccess.VIEW}
        hasContent
      >
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </PermissionGuard>
    ),
    children: [
      {
        path: '',
        element: <Navigate to="overview" replace />,
      },
      {
        path: 'overview',
        element: <ActivitiesOverviewPage />,
      },
      {
        path: 'my-activities',
        element: <ActivitiesMyPage />,
      },
      {
        path: 'all',
        element: (
          <AdminGuard hasContent>
            <ActivitiesAllPage />
          </AdminGuard>
        ),
      },
    ],
  },
];
